import { FC, ReactNode, useCallback } from 'react';
import fieldLabelCss from './assets/field-label.module.scss';

type PropsType = {
  label?: ReactNode;
  htmlFor?: string;
  isRequired?: boolean;
};

const FieldLabel: FC<PropsType> = ({
  label = null,
  htmlFor = null,
  isRequired = false,
}) => {
  const renderRequiredIndicator = useCallback((): ReactNode => {
    if (!isRequired) {
      return null;
    }

    return (
      <div className={fieldLabelCss.fieldLabel__requiredIndicator}>
        *
      </div>
    );
  }, [isRequired]);

  if (!label) {
    return null;
  }

  return (
    <label className={fieldLabelCss.fieldLabel} htmlFor={htmlFor}>
      {label}
      {renderRequiredIndicator()}
    </label>
  );
};

export { FieldLabel };
